import { clear as clearAcceptedInvestmentRounds } from "./accepted-investment-rounds";
import { clear as clearInvestmentRounds } from "./investment-rounds";
import { clear as clearInvestments } from "./investments";
import { clear as clearProjects } from "./projects";
import { clear as clearSweatEquity } from "./sweat-equity";

export const clearStores = () => {
  clearProjects();
  clearInvestments();
  clearAcceptedInvestmentRounds();
  clearInvestmentRounds();
  clearSweatEquity();
};
